// A small JSON request helper for the `/admin/...` endpoints named by node builder metadata.
//
// The catalog hands the frontend endpoint paths (`options_endpoint`, `capabilities_endpoint`,
// `client_key_form.list_endpoint`, …), so there is one place that turns a path into a call and
// normalises the `{success, ...}` envelope (including actionable 200-with-success:false bodies).
import * as config from "../config.js";

export const adminUrl = (path) => `${config.REST_SERVER_URL}${path}`;

/**
 * @param {"GET"|"POST"|"PUT"|"PATCH"|"DELETE"} method
 * @param {string} path A path starting with `/`, or an absolute URL.
 * @param {object|undefined} [body]
 * @returns {Promise<object>} The parsed body, with `success` normalised and `status` added.
 */
export const adminRequest = async (method, path, body) => {
  const url = path.startsWith("http") ? path : adminUrl(path);

  let response;

  try {
    response = await fetch(url, {
      method,
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      credentials: "include",
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
  } catch (error) {
    console.log("ADMIN REQUEST ERROR: ", error);
    return { success: false, status: 0, message: error?.message || "Request failed." };
  }

  let text = "";
  try {
    text = await response.text();
  } catch (error) {
    return { success: false, status: response.status, message: `Could not read the response: ${error?.message}` };
  }

  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch (error) {
    data = {
      success: false,
      message: `Unexpected non-JSON response (HTTP ${response.status}): ${String(text).slice(0, 200)}`,
    };
  }

  return { ...data, status: response.status, success: response.ok && data?.success !== false };
};

/** `endpoint` may contain `{name}` (the key name) for the delete route. */
export const fillEndpoint = (endpoint, params = {}) =>
  String(endpoint ?? "").replace(/\{(\w+)\}/g, (match, key) =>
    params[key] === undefined ? match : encodeURIComponent(params[key])
  );

export default adminRequest;
